/* global L, Swiper */

Wee.fn.make('map', {
	token: 'pk.eyJ1IjoicGxheWNvcmUiLCJhIjoiY2o0ZWhidnRqMDM3MzJ4cnZlbDFzZHFicCJ9.FQRlmmUwt-siRrjeODcifw',
	style: 'mapbox.streets',
	init: function() {
		var scope = this;

		$.assets.load({
			root: 'https://api.mapbox.com/mapbox.js/v3.1.1/',
			js: 'mapbox.js',
			css: 'mapbox.css',
			success: function() {
				scope.initMap();
			}
		});

		$('ref:footer').hide();
	},

	/**
	 * Initialize the map
	 */
	initMap: function() {
		var uri;

		// Add access token
		L.mapbox.accessToken = this.token;

		// Create map layer
		this.map = L.mapbox.map('map', this.style, {
			zoomControl: false,
			zoomDelta: 0.5
		})
		.setView([39.8282, -98.5795], 4.5)
		.addLayer(L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v11'));

		this.map.styleLayer = this.map.style;

		// Fit map to US bounds
		this.map.fitBounds([
			[49.175860, -124.845639],
			[24.996687, -67.656238]
		]);

		// Add markers to map
		this.addMarkers();

		// Keep internal reference to all markers and map UI elements
		this.$markers = $('.js-marker');
		this.$mapDetail = $('ref:mapDetail');
		this.$mapFilter = $('ref:mapFilter');

		// Bind events
		this.bindEvents();

		uri = $.routes.uri();

		if (uri.hash) {
			this.toggleEntryDetail(uri.hash);
		}

		if (Object.keys(uri.query).length && uri.query.type) {
			this.filterMarkers(uri.query.type);

			// Update filter select
			this.$mapFilter.val(uri.query.type);
		}
	},

	/**
	 * Add markers
	 */
	addMarkers: function() {
		var scope = this,
			locations = $.get('locations');

		if (locations.length) {
			locations.forEach(function(location) {
				scope.addMarker(location);
			});
		}
	},

	/**
	 * Add marker to map
	 * @param {object} location
	 * @param {array} location.types
	 * @param {array} location.coordinates
	 * @param {string} location.title
	 */
	addMarker: function(location) {
		var types = '',
			marker,
			popup,
			icon;

		// Generate class names for filter types
		if (location.types.length) {
			location.types.forEach(function(type) {
				if (type.type) {
					types += ' js-' + type.type;
				}
			});
		}

		// Create div icon
		icon = L.divIcon({
			className: 'marker js-marker js-' + location.id + types,
			tooltipAnchor: [0, -10],
			popupAnchor: [0, -10]
		});

		// Attach div icon to marker instance
		marker = L.marker(location.coordinates, {
			icon: icon
		}).addTo(this.map);

		// Add dynamic background color, with @blue being the default
		// Default to the first category type
		if (location.types.length) {
			marker._icon.style.backgroundColor = location.types[0].color;
		}

		// Bind tooltip to marker
		marker.bindTooltip($.view.render('map.miniPopup', location.title), {
			direction: 'top',
			opacity: 1
		});

		// Bind popup to marker
		popup = marker.bindPopup($.view.render('map.popup', location));

		// Add gallery
		popup.on('popupopen', function() {
			Swiper('.js-popup-slideshow', {
				pagination: '.swiper-pagination',
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				paginationClickable: true
			});

			$.setRef();
		});

		$('.js-detail-toggle-' + location.id).on('click.map', function() {
			popup.closePopup();
		}, {
			delegate: 'ref:map'
		});

		// Remove tooltip when clicking on marker for popup
		marker.on('click', function() {
			marker.closeTooltip();
		});
	},

	/**
	 * Bind events
	 */
	bindEvents: function() {
		var scope = this;

		scope.$mapFilter.on('change.map', function(e, el) {
			var val = el.value;

			if (val === 'all') {
				scope.showAllMarkers();
			} else {
				scope.filterMarkers(val);
				scope.updateQueryString(val);
			}
		});

		// Toggle entry detail on map marker click
		$('ref:detailToggle').on('click.map', function(e, el) {
			var id = $(el).data('id'),
				hash = parseInt($.routes.uri().hash);

			if (! hash || hash !== id) {
				scope.toggleEntryDetail(id);
			}
		}, {
			delegate: 'ref:map'
		});

		// Close entry detail sidebar when map is clicked
		scope.map.on('click', function() {
			scope.closeSidebar();
		});
	},

	/**
	 * Build url path
	 *
	 * @param {boolean} removeHash
	 */
	buildPath: function(removeHash) {
		var uri = $.routes.uri(),
			url = uri.path;

		if (removeHash) {
			uri.hash = '';
		}

		if (Object.keys(uri.query).length) {
			url += '?' + $.serialize(uri.query);
		}

		if (uri.hash) {
			url += '#' + uri.hash;
		}

		return url;
	},

	/**
	 * Update the query string with query string and hash
	 *
	 * @param {string|boolean} val
	 */
	updateQueryString: function(val) {
		var uri = $.routes.uri();

		// Update routes uri query object
		uri.query = {
			type: val
		};

		// Update query string without refreshing page
		this.updatePushState(this.buildPath());
	},

	/**
	 * Filter map markers
	 *
	 * @param {string} value - filter value
	 */
	filterMarkers: function(value) {
		// Hide all markers on filter
		this.hideAllMarkers();

		// Loop through all markers and show them based on filter value
		this.$markers.each(function(marker) {
			var $marker = $(marker);

			if ($marker.hasClass('js-' + value)) {
				$marker.show();
			}
		});
	},

	/**
	 * Load in entry html with ajax and initialize any relevant logic
	 *
	 * @param {int} entryId
	 */
	toggleEntryDetail: function(entryId) {
		var scope = this;

		if (! scope.sidebarOpen()) {
			scope.openSidebar();
		} else {
			scope.overlay(true);
		}

		Wee.data.request({
			url: '/ajax/nds/entry/' + entryId,
			method: 'get',
			success: function(html) {
				// Append entry data
				$('ref:mapDetailInner').html(html);

				// Create slider instance for top of entry
				Swiper('.js-gallery-' + entryId, {
					nextButton: '.js-swiper-button-next-' + entryId,
					prevButton: '.js-swiper-button-prev-' + entryId,
					pagination: '.js-swiper-pagination-' + entryId,
					paginationClickable: true
				});

				// Initialize any block galleries
				Wee.gallery.init();

				$('.js-sidebar-close').on('click.map', function() {
					scope.closeSidebar();
				});

				// Refresh hash reference
				$.routes.uri().hash = entryId;

				// Fade out loader overlay
				setTimeout(function() {
					scope.overlay();
				}, 200);
			}
		});
	},

	/**
	 * Fade in/out the overlay
	 *
	 * @param {boolean} show
	 */
	overlay: function(show) {
		var $overlay = $('ref:mapDetailOverlay'),
			$spinner = $('ref:mapDetailSpinner'),
			disabled = '-is-disabled';

		if (show) {
			$spinner.show();
			$overlay.show().
				removeClass(disabled);
			this.$mapDetail.addClass(disabled);
		} else {
			$spinner.hide();
			$overlay.addClass(disabled);
			this.$mapDetail.removeClass(disabled);
			setTimeout(function() {
				$overlay.hide();
			}, 200);
		}
	},

	/**
	 * Show all markers
	 */
	showAllMarkers: function() {
		$.routes.uri().query = {};

		this.updatePushState();

		this.$markers.show();
	},

	/**
	 * Update push state
	 *
	 * @param {string} [path]
	 */
	updatePushState: function(path) {
		path = path || $.routes.uri().path;

		$._win.history.pushState({
			path: path
		}, '', path);
	},

	/**
	 * Hide all markers
	 */
	hideAllMarkers: function() {
		this.$markers.hide();
	},

	/**
	 * Close the detail sidebar
	 */
	closeSidebar: function() {
		var scope = this;

		scope.$mapDetail.removeClass('-is-active');

		history.replaceState(false, '', this.buildPath(true));

		$.events.off('.js-sidebar-close', 'click');

		// Wait until transition is complete before removing HTML
		setTimeout(function() {
			$('ref:mapDetailInner').html('');
			scope.overlay(true);
		}, 200);
	},

	/**
	 * Open the detail sidebar
	 */
	openSidebar: function() {
		this.$mapDetail.addClass('-is-active');
	},

	sidebarOpen: function() {
		return this.$mapDetail.hasClass('-is-active');
	},

	/**
	 * Destroy map and unbind events
	 */
	unload: function() {
		this.map.remove();
		$.events.off(null, '.map');
		$('ref:footer').show();
	}
});
